import client from "../libs/HttpClient";

class TestimonialServices {
  static testimonialList(request) {
    
    const page_no = request.queryKey[1];
    return client.get(`/testimonial?page=${page_no}`, request);
  }
  static addTestimonial(request) {
    return client.post(`/add-testimonial`, request, {});
  }
  static updateTestimonial(request) {
    return client.post(`/edit-testimonial`, request, {});
  }
  static viewTestimonial(params) {
    return client.get(`get-testimonial`, { params });
  }
  static deleteTestimonial(params) {
    return client.delete(`delete-testimonial`, { params });
  }
  static updateStatusTestimonial(request) {
    return client.post(`/testimonial-status`, request);
  }
}

export { TestimonialServices };
